import React, { useContext } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { reorderSubMenuItems } from './orderedSubMenuItems'
import { hiddenSubmenu } from './requiredPermissions'
import { RootDataContext } from './utils'
import lodashGet from 'lodash.get'
import MissingPage from 'pages/others/MissingPage'
import { isEnterprise } from 'lib/auth'
import { SplitContext } from 'containers/SplitContext'
import { isLegacyDbpRouteBlocked } from './checksForFeatureFlag'

export const PrivateRoute = ({ component: Component, isEnterpriseRoute, ...rest }) => {
  const { displayedMenu, isLoggedIn, redirectToLogin, refresh } =
    useContext(RootDataContext)
  const { splits } = useContext(SplitContext)

  if (isEnterpriseRoute && !isEnterprise()) {
    return <Route {...rest} render={() => <MissingPage />} />
  }

  const menuPath = rest.path.split('/')[1]
  const submenuPath = rest.path.split('/')[2]
  const hasAccessToMenu = Boolean(displayedMenu[menuPath])
  const hasAccessToSubMenu = Boolean(displayedMenu[menuPath]?.some(
    (v) => v === submenuPath
  ))

  const filteredMenu = Object.keys(displayedMenu).reduce((result, menu) => {
    result[menu] = displayedMenu[menu].filter((submenu) =>
      !lodashGet(hiddenSubmenu, menu, []).includes(submenu)
    )
    return result
  }, {})

  return (
    !refresh && (
      <Route
        {...rest}
        render={(routeProps) => {
          if (isLegacyDbpRouteBlocked(routeProps.location.pathname, splits)) {
            return <MissingPage />
          }
          if (!hasAccessToMenu || !hasAccessToSubMenu) {
            return <MissingPage />
          }
          return !redirectToLogin ? (
            <Component
              {...routeProps}
              menu={reorderSubMenuItems(filteredMenu)}
            />
          ) : (
            <Redirect
              to={{
                pathname: isLoggedIn ? '/user/logout' : '/login',
                state: { from: routeProps.location },
              }}
            />
          )
        }}
      />
    )
  )
}
